var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 48,
    viewBox: "0 0 54 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_699_1836)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 44,
    height: 38,
    rx: 8,
    fill: "#2D2C3C",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_699_1836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.59 13.59C32.21 13.21 31.7 13 31.17 13H20C18.89 13 18 13.9 18 15V29C18 30.1 18.9 31 20 31H34C35.1 31 36 30.1 36 29V17.83C36 17.3 35.79 16.79 35.41 16.42L32.59 13.59ZM27 29C25.34 29 24 27.66 24 26C24 24.34 25.34 23 27 23C28.66 23 30 24.34 30 26C30 27.66 28.66 29 27 29ZM28 19H22C20.9 19 20 18.1 20 17C20 15.9 20.9 15 22 15H28C29.1 15 30 15.9 30 17C30 18.1 29.1 19 28 19Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_699_1836",
    x: 0,
    y: 0,
    width: 54,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_699_1836"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_699_1836",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_699_1836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PdfIcon.8860a063fdd6e63ef16f8fdd140096c9.svg";
export { ForwardRef as ReactComponent };